// Shared blog posts data for consistency across components
import babyBlogImage from '../assets/baby_blog_1.png';
import babyFeedingBlogImage from '../assets/baby_feeding_blog.png';
import canadianBabyProducts2025BlogImage from '../assets/canadian_baby_products_2025_blog.png';
import hydroflowHero from '../assets/hydroflow_blog_hero_1200x630.png';

export const getBlogPosts = () => [
  {
    id: 1,
    slug: "sustainable-baby-products-canada",
    title: "Sustainable Baby Products: Why They Matter",
    excerpt: "New moms and dads today care deeply about using sustainable baby products that are safe for both their baby and the planet.",
    date: "2025-06-18",
    readTime: "5 min read",
    category: "Baby",
    image: babyBlogImage,
    author: "OriginSelect Team",
  },
  {
    id: 2,
    slug: "safe-baby-feeding-guide-canada",
    title: "The Complete Guide to Safe Baby-Led Weaning: Non-Toxic Feeding Products for Canadian Parents",
    excerpt: "Discover everything you need to know about safe baby-led weaning, from understanding what makes feeding products truly safe to choosing the right non-toxic essentials for your Canadian family.",
    date: "2025-07-01",
    readTime: "8 min read",
    category: "Baby",
    image: babyFeedingBlogImage,
    author: "OriginSelect Team",
  },
  {
    id: 3,
    slug: "top-canadian-baby-products-2025",
    title: "Top Canadian Baby Products for 2025: Safe, Local, and Parent-Approved",
    excerpt: "Discover the best Canadian-made baby products that are loved by parents and approved for little ones. From safe feeding essentials to organic skincare, find quality products made with heart and heritage.",
    date: "2025-08-01",
    readTime: "8 min read",
    category: "Baby",
    image: canadianBabyProducts2025BlogImage,
    author: "OriginSelect Team",
  },
  {
    id: 4,
    slug: 'hydroflow-canada-review-2025',
    title: 'HydroFLOW Canada Review (2025): Salt-Free Water Conditioning for Homes, Cottages & RVs',
    excerpt: 'Compare HydroFLOW Pearl, Pearl PLUS, HS40 and K40 AquaKlear for Canadian homes, cottages, RVs and pools. Benefits, sizing and when to choose each.',
    date: '2025-08-08',
    readTime: '7 min read',
    category: 'Home',
    image: hydroflowHero,
    author: 'OriginSelect Team'
  }
];

// Get featured blog posts for homepage (most recent + most relevant)
export const getFeaturedBlogPosts = () => {
  const posts = getBlogPosts();
  // Sort by date (newest first) and return top 3
  return posts
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, 3);
};

// Format date for display
export const formatBlogDate = (dateString) => {
  if (dateString === "2025-07-01") {
    return "07/01/2025";
  }
  
  const date = new Date(dateString + "T12:00:00");
  return date.toLocaleDateString('en-US', { 
    year: 'numeric', 
    month: '2-digit', 
    day: '2-digit' 
  });
};
